import React from 'react';
import { Constants } from '@pwc/pwc-deals-web-common';
import DraftPill from './DraftPill';
import SharedPill from './SharedPill';

const VersionStatus = ({
  content,
  allowDraftPill = true,
  hideTextVersion = false,
}) => {
  const draftStatuses = [
    Constants.VERSION_STATUS.DRAFT,
    Constants.VERSION_STATUS.APPROVAL_REJECTED,
  ].map((_) => _.value);
  if (!content) return null;

  const draftVersionNumber = draftStatuses.includes(content.versionStatus)
    ? content.versionNumber
    : null;

  let sharedVersionNumber;
  if (
    content.versionStatus ===
      Constants.VERSION_STATUS.APPROVAL_REQUESTED.value ||
    content.versionStatus === Constants.VERSION_STATUS.APPROVED.value
  ) {
    sharedVersionNumber =
      content.versionNumber > 0 ? content.versionNumber - 1 : null;
  } else {
    const isDraftVersionGreaterThanOne =
      draftVersionNumber && draftVersionNumber > 1
        ? draftVersionNumber - 1
        : null;
    sharedVersionNumber =
      content.versionStatus === Constants.VERSION_STATUS.SHARED.value ||
      content.versionStatus ===
        Constants.VERSION_STATUS.SHARED_WITH_THIRD_PARTY.value
        ? content.versionNumber
        : isDraftVersionGreaterThanOne;
  }

  return (
    <>
      <SharedPill
        hideTextVersion={hideTextVersion}
        version={sharedVersionNumber}
      />
      {allowDraftPill && (
        <DraftPill
          hideTextVersion={hideTextVersion}
          version={draftVersionNumber}
        />
      )}
    </>
  );
};

export default VersionStatus;
